import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { UserSession } from '../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { NprLookup } from '../../service/api-service';
import S3ImagePreview from '../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../assets/placeholder';
import MultiDropdownApi from '../../components/MultiDropdownApi';
import ImageS3Upload from '../../components/ImageS3Upload';
import { v4 as uuid } from 'uuid';
import { addEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import IntervalDropdown from '../../components/IntervalDropdown';
import { add, update } from '../../service/equipmentListService';

export default function EquipmentListAdd(modalProps: any) {

  const details = modalProps?.details;

  const id = modalProps?.uuid;

  async function Add() {
    console.log("details == ", details);
    let updateDetails: any = {
      name,
      description,
      equipment_type: equipmentType,
      s3_key: details?.s3_key || (!!file ? `equipment-list/${id}` : undefined),
      hazard
    };
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      update(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Updated Equipment', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    } else {
      add(updateDetails).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      }).catch((error) => {
        modalProps.toast.current.show({ severity: 'error', summary: 'Failed to Create Equipment', life: 3000 });
        modalProps.setGlobalLoading(false);
      })
    }
  }



  const [name, setName] = React.useState(details?.name || "");
  const [equipmentTypeObject, setEquipmentTypeObject] = React.useState<any>({});
  const [description, setDescription] = React.useState(details?.description || "");
  const [equipmentType, setEquipmentType] = React.useState(details?.equipment_type || "");
  const [hazard, setHazard] = React.useState(details?.hazard || []);
  const [photo, setPhoto] = React.useState(details?.photo || placeholder);
  const [file, setFile] = React.useState<File>();

  React.useEffect(() => {
    const hazard = equipmentTypeObject?.hazard;
    if (hazard) {
      setHazard(hazard);
    }
  }, [equipmentType])

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl>
            <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={details?.s3_key || `equipment-list/${id}`} file={file} setFile={setFile} />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>Name<div style={{ color: 'red' }}>*</div></FormLabel>
                <FormControl
                  sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
                >
                  <InputText value={name} onChange={(e) => setName(e.target.value)} type="text" className="p-inputtext-sm PrimeSmallInput" />
                </FormControl>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <DropdownApi apiPath='equipment-type' optionLabel="name" optionValue='id' label='Equipment Type' selectedData={equipmentType} setSelectedData={setEquipmentType} setSelectedObject={setEquipmentTypeObject} />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item xs={12}>
          <MultiDropdownApi
            apiPath="risk-hazard"
            optionLabel="name"
            optionValue="id"
            label="Hazard"
            selectedData={hazard}
            setSelectedData={setHazard}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Description</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <InputTextarea value={description} placeholder="Description" onChange={e => setDescription(e.target.value)} />
            </FormControl>
          </FormControl>
        </Grid>
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}